import { action, computed, observable } from 'mobx';
import axios from '../lib/axios';

class SaleStore {
  @observable categories;
  @observable allSales;
  @observable categoryId;
  @observable selectedSale;
  @observable selectedSaleContent;

  @action loadSale(id) {
    this.selectedSale = null;
    axios.get(`/sales/${id}`).then(result => this.selectedSale = result.data);
  }

  @action loadSaleContent(id) {
    this.selectedSaleContent = this.selectedSale.sale_contents.find(content => content.category.id === parseInt(id));
  }

  @action fetch() {
    this.categories = this.allSales = undefined;
    axios.get('/sales').then((result) => {
      this.categories = result.data.saleCategories;
      this.allSales = result.data.sales;
    });
  }

  @action filterCategory(categoryId) {
    this.categoryId = categoryId;
  }

  @action clearFilterCategory() {
    this.categoryId = undefined;
  }

  @computed get sales() {
    if (this.isLoading)
      return [];
    const sales = this.categoryId ?
                  this.allSales.filter((sale) => sale.sales_category_id === this.categoryId) :
                  this.allSales;
    return sales;
  }

  @computed get relatedSales() {
    if (!this.allSales)
      return [];
    return this.allSales.filter(sale => sale.id !== this.selectedSale.id).slice(0, 6);
  }

  @computed get isLoading() {
    return (!this.allSales || !this.categories);
  }
}

export default new SaleStore();



// WEBPACK FOOTER //
// ./src/stores/SaleStore.js